import { render, staticRenderFns } from "./ProjectManagerDropdown.vue?vue&type=template&id=67baa99c&scoped=true"
import script from "./ProjectManagerDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectManagerDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProjectManagerDropdown.vue?vue&type=style&index=0&id=67baa99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67baa99c",
  null
  
)

export default component.exports